import {User} from './user.model';
import {TreatmentActionModel} from './treatment-action.model';

export class VisitModel {

    flowId: string = '';
    order: number;
    marker: string;
    muac: number;
    date: Date;
    type: string;
    gestationWeek: number;
    nextVisit: string;
    result: any;
    comments: string;
    alert: string;
    stages: Array<string>;
    symptoms: Array<string>;
    anotherDisease: string;
    instructions: Array<string>;
    give: TreatmentActionModel;
    dosis: TreatmentActionModel;
    takeChildToHospital: TreatmentActionModel;
    forwardToHospital!: boolean;
    healthAssistant: User;
    fowardToHospital: boolean; // Deprecated
    hospitalName: string;
    hospitalNumber: string;
    referToHospital: boolean;
    hospitalizationCause: string[] = [];
    alertIcon: any;
    appVersion: string;

    completed = false;

    newProtocol: boolean;
    weight!: number | null; // Can edit
    height!: number | null; // Can edit
    imc!: number | null; // TODO verify this field
    imcRangeIndicator!: string; // TODO verify this field
    imcLevel!: string; // TODO verify this field
    level: string = '';
    diagnosis?: string; // TODO verify this field
    rangeIndicator: string = '';
    weightLevel: string = '';
    weightRangeIndicator: string = '';
    heightLevel: string = '';
    heightRangeIndicator: string = '';
    heightToWeightLevel: string = ''; // TODO verify this field
    heightToWeightIndicator: string = ''; // TODO verify this field
    sachetsCount!: number | null;
    sachetsInformation!: string | null;
    dailySachetsCount!: number | null;
    sachetsKcal!: number | null;
    sachetImage!: string | null;
    sachetInfo!: string | null;
    sachetsDaily!: number | null;
    childMonths!: number | null;
    vaccinationUnity!: string | null;
    vaccines = new Array<string>();
    vaccinationDate!: Date; // TODO verify this date if vaccination is done
    dewormingDate!: Date; // TODO check this field
    dewormingPeriod!: string;
    hospitalizationCauses: string[] = [];
    constructor(date?: Date, marker?: string) {
        this.marker = marker;
        this.date = date;
    }

}
